import { useNavigate } from "react-router-dom";
import { styled } from "styled-components";
import back_arrow from "../../assets/back_arrow.svg"; // Adjust path as needed

const StyledBackButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

interface BackButtonProps {
  className?: string;
  onClick?: () => void;
}

export const BackButton = ({ className, onClick }: BackButtonProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <StyledBackButton
      className={className}
      onClick={handleClick}
      aria-label="Go back"
    >
      <img src={back_arrow} alt="Back" />
    </StyledBackButton>
  );
};
